export enum CookLeaveTypes {
    LONG_LEAVE = 'LONG_LEAVE',
    SHORT_LEAVE = 'SHORT_LEAVE'
}
